import getColor from "@insite/mobius/utilities/getColor";
import { categoryDetailSubCategoriesStyles } from "@waytek/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalGuardianBlue: getColor("common.global.guardianBlue"),
    globalIndustrialTaupe: getColor("common.global.industrialTaupe")
};

categoryDetailSubCategoriesStyles.container = {
    ...categoryDetailSubCategoriesStyles.container,
    css: css`
        width: calc(100% + 15px);
        margin-left: -7.5px;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    ...categoryDetailSubCategoriesStyles.subCategoryItem,
    width: [6, 6, 6, 4, 4],
    css: css`
        padding: 7.5px;
        align-items: stretch;
    `,
};

categoryDetailSubCategoriesStyles.innerContainer = {
    ...categoryDetailSubCategoriesStyles.innerContainer,
    css: css`
        &&& {
            > div {
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                height: 100%;
            }
        }
    `,   
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    ...categoryDetailSubCategoriesStyles.subCategoryImageItem,
    width: 12,
    css: css`
        border: 1px solid ${localColors.globalIndustrialTaupe};
        border-bottom: 0;
        justify-content: center;
        &&& {
            span {
                text-decoration: none;
                border-bottom: 0;
            }

            img {
                width: auto;
                height: auto;
                height: 190px;

                ${mediaQueriesBP.maxMD} {
                    height: 120px;
                }
            }
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImage = {
    ...categoryDetailSubCategoriesStyles.subCategoryImage,
    css: css`
        width: 100%;
        padding: 10px;

        p {
            height: 190px;
            display: flex;
            align-items: center;
            justify-content: center;

            ${mediaQueriesBP.maxMD} {
                height: 120px;
            }
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {
    ...categoryDetailSubCategoriesStyles.subCategoryNameLinkItem,
     width: 12,
     css: css`
        border: 1px solid ${localColors.globalIndustrialTaupe};
        padding: 20px 25px;
        &&& {
            span {
                text-decoration: none;
                border-bottom: 0;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        ${mediaQueriesBP.maxMD} {
            padding: 10px 15px;
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    ...categoryDetailSubCategoriesStyles.subCategoryNameLink,
    css: css`
        font-weight: 700;
        text-decoration: none;
        border-bottom: 0;
        &&& {
            span {
                color: ${localColors.globalGuardianBlue};
            }
        }
    `,
};